import {bindEvent, submitForm, runNewScripts} from "../utils/functions";
import axios from "axios";
import {injectOverlay} from "./overlay";

class ModalDialog {
    constructor(element, autocomplete = null) {
        if (ModalDialog.instance)
            return ModalDialog.instance
        this.formLoaded = false
        this.autocomplete = autocomplete || null
        this.currentModalContentWrapperId = "";
        this.currentFormUrl = "";
        this.formStack = []
        this.modalDialog = element
        this.bodyElement = element.querySelector('.modal-card-body.st-body')
        this.loadingElement = element.querySelector('.modal-card-body.st-loading')

        this.replaceLinkSelector = "a[data-replace-to-modal]"
        this.loadLinkSelector = "a[data-load-to-modal]"

        this.initEvents()
        ModalDialog.instance = this
    }

/*    defaultOnFormSave() {
        alert("AAAA")
    }*/

    show() {
        this.modalDialog.classList.toggle("is-active", true);
    }

    hide(clear=false) {
        if (clear) {
            this.formStack = []
            this.bodyElement.innerHTML = ""
            this.startLoading();
        }
        this.modalDialog.classList.remove("is-active")
    }

    startLoading() {
        this.bodyElement.classList.add("is-hidden");
        this.loadingElement.classList.remove("is-hidden");
    }

    stopLoading() {
        this.bodyElement.classList.remove("is-hidden");
        this.loadingElement.classList.add("is-hidden");
    }

    initEvents() {
        // Příklad zavření modálního okna
        const closeButton = this.modalDialog.querySelector('.close-modal');
        if (closeButton) {
            closeButton.addEventListener('click', () => this.closeForm());
        }

        // TODO: ulozeni formulare
    }

    storeForm() {
        if (! this.formLoaded)
            return
        console.log('storeForm');
        const stack_item = {
            wrapperId: this.currentModalContentWrapperId,
            formUrl: this.currentFormUrl,
            autocomplete: this.autocomplete,
            title: this.modalDialog.querySelector('.modal-card-title').innerHTML,
            // TODO: title, width, ...?
        }
        this.formStack.push(stack_item)
    }

    restoreForm() {
        // console.log("restoreForm")
        if (! this.formStack.length)
        {
            this.formLoaded = false;
            return
        }
        const stack_item = this.formStack.pop()
        document.getElementById(this.currentModalContentWrapperId).remove(); // remove the topmost visible modal contents
        document.getElementById(stack_item.wrapperId).classList.remove("is-hidden") // unhide the previous modal contents
        this.currentModalContentWrapperId = stack_item.wrapperId; // assign the previous modal content wrapper ID as current
        this.currentFormUrl = stack_item.formUrl;
        this.setLinkToFullPage(this.currentFormUrl)
        this.modalDialog.querySelector('.modal-card-title').innerHTML = stack_item.title
        this.autocomplete = stack_item.autocomplete
        this.show();
        // TODO bindEvent(this.modalDialog.querySelector('.modal-content'), 'submit', 'form', this.onFormSave)
        window.hlp.initHints()
    }

    setLinkToFullPage(url) {
        url = url.replace(/__modal(=True)?&?/, '')
        const linkToFullPage = this.modalDialog.querySelector('.btn-link-to-full-page')
        if (linkToFullPage) {
            linkToFullPage.href = url
        }
    }

    loadForm(url, autocomplete = null) {
        // console.log("Loading form");
        this.storeForm();
        this.startLoading();
        this.show();
        this.autocomplete = autocomplete || null;
        url = this.formatUrl(url);
        const wrapper = this.createModalContentWrapper();
        this.fetchModalContents(url, () => {
            this.hideCurrentModalContent();
            return wrapper;
        });
    }

    replaceForm(url) {
        this.startLoading();
        url = this.formatUrl(url);
        let wrapper = document.getElementById(this.currentModalContentWrapperId);
        this.fetchModalContents(url, () => {
            if(wrapper){
                wrapper.innerHTML = '';
            } else {
                wrapper = this.createModalContentWrapper();
            }
            return wrapper;
        });
    }

    refreshForm() {
        if (!this.formLoaded) return;
        this.replaceForm(this.currentFormUrl);
    }

    fetchModalContents(url, getWrapperHandler) {
        axios.get(url)
            .then(response => {
                this.setLinkToFullPage(url)
                const modalTitle = this.modalDialog.querySelector('.modal-card-title')
                let modalContentWrapper = getWrapperHandler();
                modalContentWrapper.insertAdjacentHTML('beforeend', response.data); // insert received html into the wrapper
                modalContentWrapper.id = this.generateRandomId();
                this.currentModalContentWrapperId = modalContentWrapper.id;
                this.currentFormUrl = url;
                modalTitle.innerHTML = this.decodeMimeEncodedWord(response.headers.get("X-Page-Title"));

                if (this.autocomplete) {
                    // console.log("Binding form submit to autocomplete", this.autocomplete);
                    bindEvent(
                        modalContentWrapper,
                        'submit',
                        'form',
                        false,
                        (event) => {
                            event.preventDefault()
                            submitForm(event.target, {}, (response) => {
                                // console.log(response.data)
                                this.autocomplete.addValue(response.data.id)
                            })
                        }
                    )
                }

                // dodatecne spusteni JS, trochu prasarna
                // The scripts are only run in the new modal content!!
                runNewScripts(modalContentWrapper);
                // Make all <a> in modal replace the modal content if marked so
                this.transformToModalLinks(modalContentWrapper, this.replaceLinkSelector, true);
                this.transformToModalLinks(modalContentWrapper, this.loadLinkSelector, false);
                // this.loadModalForm();
                this.formLoaded = true
                document.dispatchEvent(new CustomEvent('formLoaded'))
                this.stopLoading();
                this.show();
            });
    }

    transformToModalLinks(contentWrapper, selector, replaceForm) {
        contentWrapper.querySelectorAll(selector).forEach((el) => {
            if(!el.getAttribute("href")) return;

            let link = el.getAttribute("href");
            el.addEventListener("click", () => {
                if(replaceForm){
                    this.replaceForm(link);
                } else {
                    this.loadForm(link);
                }
            });
            el.setAttribute("href", "#")
        });
    }

    closeForm() {
        // console.log("closeForm")
        if (this.formStack.length === 0) {
            console.log("totalClose", this.formStack, window.hlp)
            window.hlp.initHints()
            this.hide(true);
        }
        this.restoreForm()
    }

    hideCurrentModalContent() {
        const contentWrapper = document.getElementById(this.currentModalContentWrapperId);
        console.log(contentWrapper);
        if(contentWrapper === null) return;
        contentWrapper.classList.add("is-hidden");
    }

    createModalContentWrapper() {
        const wrapper = document.createElement("section");
        this.bodyElement.appendChild(wrapper);
        return wrapper;
    }

    generateRandomId() {
        // should be random **most** of the time
        return Math.floor(Math.random() * Date.now()).toString(16) // format: "40b16e3aa6"
    }

    /**
     * Formats a given URL by ensuring the presence of the `__modal` query parameter.
     *
     * - Extracts the base URL (excluding query parameters).
     * - Parses existing query parameters.
     * - If `__modal` is not already present, appends it to the query string.
     *
     * @param {string} url - The URL to be formatted.
     * @returns {string} - The modified URL with `__modal` included as a query parameter.
     */
    formatUrl(url) {
        let slug = url.split("?")[0];
        let queryParams = url.split("?")[1];
        if(queryParams === undefined){
            queryParams = "";
        }
        const params = new URLSearchParams(queryParams);
        // add __modal if not present in the url
        if(!url.includes("__modal")){
            if(params.size){
                url = url + "&";
            } else {
                url = url + "?";
            }
            url = url + "__modal";
        }
        return url;
    }

    /**
     * Decodes a MIME encoded word.
     * @param encodedWord - The encoded word to decode, e.g., "=?utf-8?q?Hello_World?="
     * @returns {*|string} - The decoded string, or the original string if decoding fails.
     */
    decodeMimeEncodedWord(encodedWord) {
        // Match MIME encoded words of the form: =?charset?encoding?encodedText?=
        const regex = /^=\?([^?]+)\?([bBqQ])\?([^?]+)\?=$/;
        const match = encodedWord.match(regex);
        if (!match) {
            return encodedWord; // Return as-is if the format isn't recognized
        }

        const charset = match[1]; // for example, "utf-8"
        const encoding = match[2].toLowerCase(); // "q" for quoted-printable in this case
        let encodedText = match[3];

        if (encoding === 'q') {
            // In MIME Q encoding:
            // - Underscores (_) are used to represent spaces.
            // - Any sequence =XX represents a byte in hexadecimal.
            const withSpaces = encodedText.replace(/_/g, ' ');
            // Convert =XX sequences into %XX, so we can use decodeURIComponent
            const percentEncoded = withSpaces.replace(/=([A-Fa-f0-9]{2})/g, '%$1');
            // Decode the percent-encoded string to get the proper Unicode string.
            return decodeURIComponent(percentEncoded);
        } else if (encoding === 'b') {
            // For Base64-encoded text, decode using atob and TextDecoder.
            const binaryString = atob(encodedText);
            const bytes = Uint8Array.from(binaryString, char => char.charCodeAt(0));
            return new TextDecoder(charset).decode(bytes);
        }

        // If the encoding is not recognized, return the original string.
        return encodedWord;
    }
    decodeBase64(encodedString) {
        // Decode the Base64-encoded string into a binary string.
        const binaryString = atob(encodedString);

        // Convert the binary string to a Uint8Array.
        const bytes = Uint8Array.from(binaryString, char => char.charCodeAt(0));

        // Use TextDecoder to properly decode the UTF-8 data.
        return new TextDecoder("utf-8").decode(bytes);
    }
}

export default ModalDialog
